export default function initFormValidation() {
  const forms = document.querySelectorAll('.form-validation');

  if (!forms.length) return;

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const showFieldError = (field) => {
    field.classList.add('invalid');
  };

  const hideFieldError = (field) => {
    field.classList.remove('invalid');
  };

  const showFormError = (form) => {
    form.classList.add('invalid');
  };

  const hideFormError = (form) => {
    form.classList.remove('invalid');
  };

  const validateEmail = (emailInput) => {
    const value = emailInput.value.trim();

    if (!value || !emailPattern.test(value)) {
      showFieldError(emailInput);
      return false;
    }

    hideFieldError(emailInput);
    return true;
  };

  const validatePassword = (passwordInput) => {
    if (!passwordInput.value.trim()) {
      showFieldError(passwordInput);
      return false;
    }

    hideFieldError(passwordInput);
    return true;
  };

  const submitForm = async (form) => {
    const formData = new FormData(form);
    const method = (form.getAttribute('method') || 'POST').toUpperCase();
    const action = form.getAttribute('action') || window.location.href;
    const submitUrl = action === '#' ? window.location.href : action;

    const response = await fetch(submitUrl, {
      method,
      body: method === 'GET' ? undefined : formData,
      headers: {
        Accept: 'application/json, text/plain, */*',
      },
    });

    if (!response.ok) {
      throw new Error(`Submit failed with status: ${response.status}`);
    }

    const contentType = response.headers.get('content-type') || '';

    if (contentType.includes('application/json')) {
      const data = await response.json();

      if (data && (data.success === false || data.error)) {
        throw new Error('Submit failed by backend response');
      }
    }

    if (response.redirected && response.url) {
      window.location.assign(response.url);
    }
  };

  forms.forEach((form) => {
    const emailInput = form.querySelector('#email-address');
    const passwordInput = form.querySelector('#password');
    const submitButton = form.querySelector('button[type="submit"]');

    if (!emailInput || !passwordInput) return;

    if (!emailInput.name) emailInput.name = 'email';
    if (!passwordInput.name) passwordInput.name = 'password';

    hideFormError(form);
    hideFieldError(emailInput);
    hideFieldError(passwordInput);

    emailInput.addEventListener('input', () => {
      hideFormError(form);
      validateEmail(emailInput);
    });

    passwordInput.addEventListener('input', () => {
      hideFormError(form);
      validatePassword(passwordInput);
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      hideFormError(form);

      const isEmailValid = validateEmail(emailInput);
      const isPasswordValid = validatePassword(passwordInput);

      if (!isEmailValid || !isPasswordValid) {
        return;
      }

      try {
        if (submitButton) submitButton.disabled = true;
        await submitForm(form);
      } catch {
        showFormError(form);
      } finally {
        if (submitButton) submitButton.disabled = false;
      }
    });
  });
}
